import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import { ThemeProvider } from "@material-ui/styles";
import { withStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

//import Button from '@material-ui/core/Button';

import { actions } from "./../reducers/reducer";

import theme from "./../theme.js";

const styles = {
  paper: {
    padding: '6px 16px',
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main,
  }, 
};

class CardsDecks extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
  }

  render() {
    return (
      <div>
        <ThemeProvider theme={theme}>
          <div>
            Decks
          </div>
        </ThemeProvider>
      </div>
    ) 
  }
}

CardsDecks.propTypes = {
  classes: PropTypes.object.isRequired
};

const withMediaQuery = (...args) => Component => props => {
  const mediaQuery = useMediaQuery(...args);
  return <Component mediaQuery={mediaQuery} {...props} />;
};

const mapStateToProps = state => ({
});

export const CardsDecksContainer = connect(mapStateToProps, actions)(CardsDecks);

export default withStyles(styles)(withMediaQuery('(max-width:600px)')(CardsDecksContainer));
